import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import EnTitle from './EnTitle';
import FlowLines from './FlowLines';

// The charcoal "CONTACT US" band that closes every public page (except the
// contact page itself) right above the footer, as on the corporate site.
export default function ContactSection() {
  const { t } = useLanguage();
  return (
    <section className="relative bg-charcoal text-white overflow-hidden border-b border-white/10">
      <FlowLines className="opacity-70" />
      <div className="relative w-[90%] max-w-7xl mx-auto py-16 lg:py-24 grid grid-cols-1 lg:grid-cols-[1fr_auto] gap-8 lg:gap-16 items-end">
        <EnTitle lines={['CONTACT', 'US']} blue={[0]} light sub={t('home.contactSub')}
          className="text-6xl sm:text-7xl lg:text-8xl xl:text-9xl" />
        <div className="max-w-sm">
          <p className="text-sm leading-relaxed text-white/90 mb-6">{t('home.contactText')}</p>
          <Link to="/contact" className="btn-primary btn-arrow text-sm min-w-[180px] justify-between">{t('home.contactButton')}</Link>
        </div>
      </div>
    </section>
  );
}
